export default class BannerImage {
  constructor({ sizeKey, filename, url }) {
    this.sizeKey = sizeKey;
    this.filename = filename;
    this.url = url;
  }
}
